import axios from "axios";
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";
const STATES = ["not_enrolled", "enrolled"]

//
// update student's newState (enrolled or not-enrolled) in a class
//
export default function updateClassStudentState(classId, studentId, newState) {

  if(!classId  || !studentId || !newState ){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing or wrong type of params: classId:number, studentId:number, newState:string')
      })
    })
	}


  if (STATES.indexOf(newState) == -1){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('newState (string) must be one of [' + STATES.toString() + ']')
      })
    })
  }

  // this is the data structure the API wants
  const toServer = {
    state: STATES.indexOf(newState),
	}

	return new Promise((resolve, reject) => {
		axios.put(APIAddress, {'uri': `/u_clsstdtstt/${classId}/${studentId}/`,
    'data': JSON.stringify(toServer),
    'method': 'PUT',
    'token': localStorage.getItem('token')})
		.then((res) => {
			resolve(res.data);
		})
		.catch((err) => {
			console.error(err);
			reject(err);
		})
	})
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/class/updateClassStudentState.js